import { OrdersFormViewModel, VehicleOrderViewModel } from '@ail/orders-api'
import { IOrderForm } from '../types/interfaces'

export enum VehicleOrderStatus {
  NewRequest = 'NewRequest',
  InternalApproval = 'InternalApproval',
  OrderInProgress = 'OrderInProgress',
  SupplierConfirmation = 'SupplierConfirmation',
  PendingProduction = 'PendingProduction',
  ProductionInProgress = 'ProductionInProgress',
  OnStock = 'OnStock',
  DeliveringToLogistic = 'DeliveringToLogistic',
  InPreparation = 'InPreparation',
  PendingDeliveryConfirmation = 'PendingDeliveryConfirmation',
  Delivering = 'Delivering',
  Delivered = 'Delivered',
}

export enum GroupedOrderStatus {
  Initialized = 'Initialized',
  InProduction = 'InProduction',
  SettingUp = 'SettingUp',
  Delivered = 'Delivered',
}

export const getFormTitle = (
  form: IOrderForm | OrdersFormViewModel,
  language: string,
  formPageTitle?: boolean
): string => {
  const title = (!!form?.tr && form?.tr[language]) || form?.name || ''
  const splitTitle = title.split('|')
  return splitTitle.length > 0
    ? formPageTitle
      ? splitTitle[1]
        ? splitTitle[1]
        : splitTitle[0]
      : splitTitle[0]
    : title
}

export const getVehicleOrderStatus = (order: VehicleOrderViewModel): GroupedOrderStatus | string => {
  switch (order.status) {
    case VehicleOrderStatus.NewRequest:
    case VehicleOrderStatus.InternalApproval:
    case VehicleOrderStatus.OrderInProgress:
      return GroupedOrderStatus.Initialized

    case VehicleOrderStatus.SupplierConfirmation:
    case VehicleOrderStatus.PendingProduction:
    case VehicleOrderStatus.ProductionInProgress:
    case VehicleOrderStatus.OnStock:
      return GroupedOrderStatus.InProduction

    case VehicleOrderStatus.DeliveringToLogistic:
    case VehicleOrderStatus.InPreparation:
    case VehicleOrderStatus.PendingDeliveryConfirmation:
    case VehicleOrderStatus.Delivering:
      return GroupedOrderStatus.SettingUp

    case VehicleOrderStatus.Delivered:
      return GroupedOrderStatus.Delivered

    default:
      return ''
  }
}
